import React, {Fragment, useCallback, useEffect, useState} from 'react';
import {Link, useHistory, useRouteMatch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import lodash from 'lodash';
import moment from 'moment';

import {
    Checkbox,
    DateRangePicker,
    Pagination,
    Radio,
    ShowItemsSelect,
    ProlongModal,
    CloseDealModal,
} from '../../utilites';
import {
    pageOptions,
    contractStatuses,
    viewDocument,
    listRoles,
    extendBeforeDate,
    extensionLimitDays,
    prolongDate, typeDeal,
    dealDurationType,
    dealTypes,
    optionsPaymentAnnuityDate, inActiveDeal
} from '../../../helpers/data-constants';
import {
    stateContractReset,
    changeContractStatuses, getClientContracts,
} from '../../../redux/actions/contractAction';
import {
    saveCalculations,
} from '../../../redux/actions/quickCalculationAction';
import Loader from './Loader/Loader';
import {ActionButton, AlertModal, ConfirmModal} from '../../common';
import {
    returnStatus,
    returnTextStatus,
    containsNotActiveNotProlong,
    calculationAccess,
    getUserFromLocalStorage,
    containsNotActiveNotExpiredNotRetention,
    permissionsAccess,
    containsProlongLimitDaysDeal,
    isProlongAnnuity,
    returnAnnuityDealType, containsDifferentDealDurationTypes,
} from '../../../helpers/common';
import BuyThirdPersonModal from '../../utilites/modal/CloseModalLayout/BuyThirdPersonModal/BuyThirdPersonModal';
import BasicAlert from '../../utilites/Alert/Alert';
import {
    QUICK_CALCULATION_DATA,
} from '../../../constants/localStorageConstants';
import {authService} from '../../../services/auth-service';

import './clientContractTab.scss';
import {getCashbox} from '../../../redux/actions/handbookAction';
import { errorAccessToContractCreation } from '../../../redux/actions/clientShortInfoAction';
import useClientValidation from '../useClientValidation.hook';
import useStandardProlongDeal from "../../utilites/modal/ProlongModal/hooks/useStandardProlongDeal";
import PayAnnuityPeriod from '../../utilites/modal/PayAnnuityPeriodModal/PayAnnuityPeriod';
import {getClientContractConditions, headersClientContractTable} from "./data";
import CloseAnnuityDeal from "../../utilites/modal/CloseAnnuityDeal/CloseAnnuityDeal";

const ClientContractTab = () => {
    const {
        clientContracts: {deal, total},
        isLoading,
        changeContract,
    } = useSelector(({contract}) => contract);
    const { client } = useSelector(({ clientInfo }) => clientInfo);
    const dispatch = useDispatch();

    const [state, setState] = useState({
        currentPage: 1,
        pageRange: pageOptions[0].value,
        status: 'all',
        isProlong: false,
        isClosed: false,
        isCloseAnnuityDeal: false,
        isToTransfer: false,
        isBuyThirdPerson: {
            isOpen: false,
            data: null,
        },
        timeRange: {
            startDate: null,
            endDate: null
        }
    });
    const [clientContracts, setClientContracts] = useState(deal);
    const [selectedDeals, setSelectedDeals] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [popup, setPopup] = useState({
        isOpen: false,
        type: 'error',
        header: 'Ошибка',
        text: 'Ошибка',
    });
    const [alertMessage, setAlertMessage] = useState(null);
    const {accessFeatures} = useSelector(({user}) => user);
    const match = useRouteMatch();
    const history = useHistory();
    const clientId = history.location.pathname.split('/')[2];
    const dataActiveCashbox = authService.getActiveCashBoxId();
    const goodSpecialistRole = calculationAccess([listRoles.GOODS_SPECIALIST])
    const userInfo = getUserFromLocalStorage();
    const { validateClientId, clientIdNumber } = useClientValidation({client});
    const isExtendWithDaysLimit = accessFeatures["deal.extension.days.limit"];   
    const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"]
    const { validateProlongDeal } = useStandardProlongDeal({isExtendWithDaysLimit, isExtensionThreeImplementaition });
    const newProlongDate = isExtensionThreeImplementaition ? prolongDate.crediton.NEW_PROLONG_DATE : prolongDate.visem.NEW_PROLONG_DATE
    const isNewGlobalProlong = selectedDeals.some(deal => moment(deal?.startDate).isAfter(newProlongDate))
    const hasShort = selectedDeals.some(deal => deal.dealDuration === 'SHORT');
    const hasLong = selectedDeals.some(deal => deal.dealDuration === 'LONG');
    const ids = selectedDeals?.map(el => (el.id));

    const refreshData = useCallback(() => {
        const data = {
            size: state.pageRange,
            page: state.currentPage,
            status: returnStatus(state.status, accessFeatures['inactive_status_in_store']),
            id: clientId,
            descending: true,
            sortBy: 'id',
            startDate: state.timeRange.startDate
                ? state.timeRange.startDate.format('YYYY-MM-DD')
                : null,
            endDate: state.timeRange.endDate
                ? state.timeRange.endDate.format('YYYY-MM-DD')
                : null,
        }
        dispatch(getClientContracts(data));
    }, [dispatch, state.pageRange, state.currentPage, state.status, clientId, state.timeRange]);

    useEffect(() => {
        refreshData();
    }, [state.pageRange, state.currentPage, state.status, refreshData, changeContract]);

    useEffect(() => {
        const updateClassName = (status) => {
            const inactiveStatuses = [
                contractStatuses.ACTIVE.param,
                contractStatuses.EXPIRED.param,
                contractStatuses.TOTRANSFER.param,
                contractStatuses.UNKNOWN.param,
                contractStatuses.RETENTION.param,
                contractStatuses.GARAGE.param,
                contractStatuses.EXPIRED_PAYMENT.param,
            ];

            const isInactive = inactiveStatuses.includes(status) ||
                (status === contractStatuses.STORE.param && accessFeatures['inactive_status_in_store']);

            return isInactive ? 'accent' : 'disabled';
        };
        const formattedDeals = deal.map((i) => {
            i.checked = false;
            i.className = updateClassName(i.status);
            return i;
        });
        setClientContracts(formattedDeals);
    }, [deal]);

    useEffect(() => {
        setSelectedDeals(clientContracts.filter((i) => i.checked));
    }, [clientContracts]);

    useEffect(() => {
        return () => {
            dispatch(stateContractReset());
            dispatch(errorAccessToContractCreation(''));
        };
    }, [dispatch]);

    const handleSearchTypeChange = ({target: {id}}) => {
        setState((prev) => ({
            ...prev,
            status: id,
            currentPage: 1,
        }));
    };

    const onPageRangeChange = useCallback(({target: {value}}) => {
        setState((prev) => ({
            ...prev,
            pageRange: parseInt(value),
            currentPage: 1,
        }));
        setAllChecked(false);
    }, []);

    const handlePageChange = (page) => {
        setState((prev) => ({
            ...prev,
            currentPage: page,
        }));
        setAllChecked(false);
    };

    const handleAllContractCheck = useCallback(() => {
        setClientContracts((prev) => prev.map((item) => ({...item, checked: !allChecked})));
        setAllChecked(!allChecked);
    }, [allChecked]);

    const handleContractCheck = useCallback(
        (e) => {
            const id = clientContracts.findIndex((item) => item.id === +e.target.id);
            const newArray = lodash.cloneDeep(clientContracts);
            newArray[id].checked = !clientContracts[id].checked;
            setClientContracts(newArray);
        },
        [clientContracts],
    );

    const openModal = useCallback(
        (view) => {
          const showPopup = (text) => setPopup((prev) => ({ ...prev, isOpen: true, text }));
            const isSuitableStatus = selectedDeals[0].status === contractStatuses.ACTIVE.param ||
                selectedDeals[0].status === contractStatuses.EXPIRED.param ||
                selectedDeals[0].status === contractStatuses.EXPIRED_PAYMENT.param;

            if (!isSuitableStatus && (view !== state.isPayAnnuity || view !== state.isCloseAnnuityDeal)) {
                showPopup(inActiveDeal);
                return;
            }
            if (hasLong && hasShort) {
                showPopup(typeDeal);
                return;
            }
            if(validateProlongDeal({deals: selectedDeals, view})) {
                setAlertMessage(extendBeforeDate)
                return
            }
          const viewCloseProlongParam = view === viewDocument.isClosed || view === viewDocument.isProlong;
          const isProlongFeatureActive = (!isNewGlobalProlong && isExtensionThreeImplementaition) || isNewGlobalProlong;
          const hasMultipleLongTermDeals = (selectedDeals) => selectedDeals.filter(deal => deal.dealDuration === dealDurationType.LONG).length > 1
              && view !== viewDocument.isCloseAnnuityDeal
          const hasAnyShortTermDeal = (selectedDeals) => selectedDeals.some(deal => deal.dealDuration === dealDurationType.SHORT)

          const conditions = getClientContractConditions({
            selectedDeals,
            view,
            isProlongFeatureActive,
            userInfo,
            dataActiveCashbox,
            viewCloseProlongParam,
            isExtensionThreeImplementaition,
            isNewGlobalProlong,
            validateProlongDeal,
            validateClientId,
            isProlongAnnuity,
            hasMultipleLongTermDeals,
            containsProlongLimitDaysDeal,
            containsNotActiveNotProlong,
            containsNotActiveNotExpiredNotRetention,
            listRoles,
            containsDifferentDealDurationTypes,
            hasAnyShortTermDeal
          });

          for (const condition of conditions) {
            if (condition.check()) {
              if (condition.message) showPopup(condition.message);
              return;
            }
          }

          if (selectedDeals.length) {
            setState(prev => ({ ...prev, [view]: true }));
          }
        },
        [selectedDeals, dataActiveCashbox.value, userInfo.roles, clientIdNumber]
    );

    const handleCloseModal = useCallback(
        (view, refresh) => {
            setState((prev) => ({...prev, [view]: false}));
            if (refresh) {
                refreshData();
            }
        },
        [refreshData],
    );

    const closeAlertModal = useCallback(() => {
        setPopup((prev) => ({...prev, isOpen: false}));
    }, []);

    const closeClosedDealModal = useCallback(
        (isClosed) => {
            handleCloseModal(viewDocument.isClosed, isClosed);
        },
        [handleCloseModal],
    );

    const addToTransfer = useCallback(() => {
        const arrIds = selectedDeals.map((i) => i.id);
        handleCloseModal(viewDocument.isToTransfer);
        dispatch(changeContractStatuses(arrIds, contractStatuses.TOTRANSFER.param));
    }, [handleCloseModal, dispatch, selectedDeals]);

    const openBuyThirdPersonModal = (value) => {
        setState((prev) => ({
            ...prev,
            isBuyThirdPerson: {
                isOpen: value,
                data: null,
            },
        }));
    };

    const closeBuyThirdPersonModal = () => {
        setState((prev) => ({
            ...prev,
            isBuyThirdPerson: {
                data: null,
                isOpen: false,
            },
        }));
    };

    const onSubmitBuyThirdPerson = (data) => {
        setState((prev) => ({
            ...prev,
            isBuyThirdPerson: {
                isOpen: false,
                data,
            },
        }));
    };

    const isOldContract = (deal) => {
        if (deal) {
            const purities = deal.positions.map((i) => (
                i.names
                    .filter(n => n !== 'ч.' && n !== 'б/вст' && n !== 'с/вст' && n !== '/вставка').length
            ))
            for (let i = 0; i < purities.length; i++) {
                if (purities[i] > 1) {
                    return true;
                }
            }
            return false;
        }
    }

    const filterNames = (arr) => {
        const filterArr = arr.filter(n => n !== 'ч.' && n !== 'б/вст' && n !== 'с/вст' && n !== '/вставка')
        if (filterArr?.length > 1) {
            return {value: 0, label: filterArr.join(',')}
        }
        return {value: 0, label: filterArr[0]}
    }

    const copyDeal = () => {
        if (selectedDeals.length) {
            const deal = selectedDeals[0];
            const type = deal.type;
            const typeTab = {
                PURITY: 0,
                THINGS: 1,
                CARS: 2,
            }

            if (
                deal.status === contractStatuses.ACTIVE.param ||
                deal.status === contractStatuses.EXPIRED.param ||
                deal.status === contractStatuses.TOTRANSFER.param
            ) {
                setPopup((prev) => ({
                    ...prev,
                    isOpen: true,
                    text: 'Невозможно копировать договор в активном статусе',
                }));
                return;
            }

            if (isOldContract(deal) && !permissionsAccess('deal.copy.old_contract')) {
                setPopup((prev) => ({
                    ...prev,
                    isOpen: true,
                    text: 'Договор c  несколькими изделиями в наименовании может копировать только администратор',
                }));
                return;
            }

            const data = {
                calculation: {
                    amount: deal.amount,
                    months: optionsPaymentAnnuityDate.find(date => date.value === Number(deal.months)),
                    firstPaymentDate: deal.firstPaymentDate,
                    endDate: moment().format('YYYY-MM-DD'),
                    waiverOfRedemption: false
                },
                dealForm: deal.form,
                calculationTab: 0,
                typeTab: typeTab[type],
                coupon: {label: deal.couponName, value: deal.couponId},
                cashbox: {label: deal.cashBox, value: deal.cashBoxId},
            };

            if (type === 'PURITY') {
                data.purities = deal.positions.map((i) => ({
                    grossWeight: i.grossWeight,
                    pureWeight: i.pureWeight,
                    quantity: i.quantity,
                    jewel: filterNames(i.names),
                    isPart: i.names.includes('ч.'),
                    purity: {value: i.purityId, label: `${i.purityType} ${i.purityName}`},
                    puritiesComment: i.comment,
                    showComment: i.comment,
                    additionalInfo: i.additionalInfo
                }));
            }

            if (type === 'THINGS') {
                const {imei, model, names, quantity, serialNumber, additionalInfo} = deal.positions[0]
                data.things = {
                    comment: '',
                    estimatedValue: '',
                    imei: imei,
                    model: model,
                    name: names[0],
                    quantity: quantity,
                    sn: serialNumber,
                    additionalInfo: additionalInfo
                };
            }

            if (type === 'CARS') {
                const {
                    names,
                    model,
                    carDate,
                    estimatedValue,
                    vin,
                    registrationNumber,
                    certificateNumber,
                    marketPrice,
                    storageInCashBox,
                    stateOFTheVehicle,
                    additionalInformation,
                    certificateDate
                } = deal.positions[0];

                data.cars = {
                    comment: '',
                    makeOfCar: {label: names[0], value: 1},
                    model: {label: model, value: model},
                    year: {label: carDate, value: carDate},
                    estimatedPrice: estimatedValue,
                    VIN: vin,
                    carNumber: registrationNumber,
                    registrationNumber: certificateNumber,
                    registrationDate: certificateDate,
                    marketPrice: marketPrice,
                    garage: 'Без хранения в ломбарде',
                    condition: stateOFTheVehicle,
                    additionalInfo: additionalInformation,
                };
            }

            if (goodSpecialistRole && deal.cashBox !== dataActiveCashbox.label) {
                data.cashbox = {label: dataActiveCashbox.label, value: dataActiveCashbox.value}
                data.coupon = {label: '', value: ''}
            }
            if (permissionsAccess("action.cashbox.process_available_cashboxes.find_all_by_activeis")) {
                dispatch(getCashbox({id: deal.cashBoxId, type: dealTypes[deal.form].couponType}))
            }

            localStorage.setItem(QUICK_CALCULATION_DATA, JSON.stringify(data));
            history.push({pathname: `/client/${clientId}/contract`});
            dispatch(saveCalculations());
        }
    };

    const handleFilterChange = (str, value) => {
        setState({
            ...state,
            timeRange: value
        })
    }

    return (
        <>
            <div className="content-inner-data-container">
                <div className="content-datatable">
                    <div className="content-datatable-header sticky">
                        <div className="content-datatable-header-left">
                            <div className="action-items">
                                <div className="pillbox-radiogroup" onChange={handleSearchTypeChange}>
                                    <Radio
                                        pillboxStyle={true}
                                        label="Все договоры"
                                        id="all"
                                        name="radioNameContractsSwitcher"
                                        checked={true}
                                    />
                                    <Radio
                                        pillboxStyle={true}
                                        label="Активные"
                                        id="active"
                                        name="radioNameContractsSwitcher"
                                    />
                                    <Radio
                                        pillboxStyle={true}
                                        label="Неактивные"
                                        id="canceled"
                                        name="radioNameContractsSwitcher"
                                    />
                                    {/* <Radio pillboxStyle={true} label='Компенсация' id='compensation' name='radioNameContractsSwitcher' /> // todo on completion */}
                                </div>
                            </div>
                        </div>
                        <div className="content-datatable-header-right">
                            <div className="action-items">
                                <DateRangePicker
                                    coverClass="form-element"
                                    startDate={state.timeRange.startDate}
                                    endDate={state.timeRange.endDate}
                                    onChange={(v) => handleFilterChange('timeRange', v)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content-datatable-header">
                        <div className="content-datatable-header-left">
                            <div className="action-items">
                                {permissionsAccess("action.deal.closure") &&
                                    <ActionButton text="Закрыть" func={openModal} param={hasShort ? viewDocument.isClosed : viewDocument.isCloseAnnuityDeal}
                                        styleName={clientIdNumber ? 'disabled-action-item' : 'action-item' }/>}
                                {permissionsAccess("action.deal.extension") &&
                                    <ActionButton text="Продлить" func={openModal} param={viewDocument.isProlong} 
                                        styleName={clientIdNumber ? 'disabled-action-item' : 'action-item' }/>}
                                {permissionsAccess("action.deal.extension") &&
                                    <ActionButton text="Аннуитетные платежи" func={openModal} param={viewDocument.isPayAnnuity}
                                        styleName={clientIdNumber ? 'disabled-action-item' : 'action-item' }/>}
                                {permissionsAccess("action.deal.status.transfer") && (
                                    <ActionButton
                                        text="На передачу / В гараж"
                                        func={openModal}
                                        param={viewDocument.isToTransfer}
                                    />
                                )}
                                {permissionsAccess("action.deal.create") && selectedDeals.length < 2 && (
                                    <ActionButton text="Копировать" func={copyDeal}/>
                                )}
                            </div>
                        </div>
                        <div className="content-datatable-header-right">
                            <div className="action-items">
                                <ShowItemsSelect options={pageOptions} change={onPageRangeChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="content-datatable-content">
                        {isLoading ? (
                            <Loader pageRange={state.pageRange}/>
                        ) : (
                            <table className="table hover">
                                <thead>
                                <tr>
                                    <th scope="col">
                                        <Checkbox
                                            label="Номер договора"
                                            id="checkboxContractSelectAll"
                                            name="checkboxContractSelectAll"
                                            onChange={handleAllContractCheck}
                                            value={allChecked}
                                        />
                                    </th>
                                    <th scope="col">
                                        <p>Подразделение</p>
                                    </th>
                                    <th scope="col">
                                        <div className="clientContractTab-table-body-box">
                                            <div className="clientContractTab-table-body-box-name">
                                                <p>Название</p>
                                            </div>
                                            <div className="clientContractTab-table-body-box-model">
                                                <p>Модель</p>
                                            </div>
                                            <div className="clientContractTab-table-body-box-weight">
                                                <p>Вес, г.</p>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Статус <br/>
                                            договора
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Тип <br/>
                                            договора
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Срок <br/>
                                            предоставления займа
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Сумма <br/>
                                            микрозайма, руб.
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Процент <br/>
                                            займа
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Процент <br/>
                                            неустойки
                                        </p>
                                    </th>
                                    <th scope="col">
                                        <p>
                                            Сумма <br/>
                                            на выкуп, руб.
                                        </p>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="clientContractTab-table-body">
                                {clientContracts &&
                                    clientContracts.length !== 0 &&
                                    clientContracts.map((item) => {
                                        return (
                                            <tr className={item.className} key={item.id}>
                                                <td>
                                                    <div className="table-cellcontent">
                                                        <Checkbox
                                                            id={item.id}
                                                            name={item.id}
                                                            onChange={handleContractCheck}
                                                            value={item.checked}
                                                        />
                                                        <Link href="#" to={`${match.url}/${item.id}`}
                                                              className="table-link">
                                                            <span>{item.dealNumber || item.id}</span>
                                                        </Link>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p>{item.cashBox || '-'}</p>
                                                </td>
                                                <td>
                                                    <div className="clientContractTab-table-body-group">
                                                        {item.positions &&
                                                            item.positions.length !== 0 &&
                                                            item.positions.map((i, ind) => (
                                                                <div
                                                                    className="clientContractTab-table-body-box"
                                                                    key={i.names.join() + ind}>
                                                                    <div
                                                                        className="clientContractTab-table-body-box-name">
                                                                        <p>{i.names.join(' ')}</p>
                                                                    </div>
                                                                    <div
                                                                        className="clientContractTab-table-body-box-model">
                                                                        <p>{i.model ? i.model : '-'}</p>
                                                                    </div>
                                                                    <div
                                                                        className="clientContractTab-table-body-box-weight nowrap">
                                                                        <p>{i.pureWeight ? (+i.pureWeight).toFixed(2) : '-'}</p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </td>
                                                <td>
                                                    <p className={item.status === contractStatuses.ACTIVE.param ? undefined : 'nowrap'}>
                                                        {returnTextStatus(item.status).replace('/', '/\n')}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>
                                                        <nobr>{returnAnnuityDealType(item.dealDuration)}</nobr>
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>
                                                        {moment(item.startDate).format('DD.MM.YYYY')} — <br/>
                                                        {moment(item.endDate).format('DD.MM.YYYY')}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>{item.amount.toFixed(2)}</p>
                                                </td>
                                                <td>
                                                    <p>{item.basePercent.toFixed(2)}</p>
                                                </td>
                                                <td>
                                                    <p>{item.delayPercent.toFixed(2)}</p>
                                                </td>
                                                <td>
                                                    <p>{item.refundAmount.toFixed(2)}</p>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
            <ProlongModal
                isOpen={state.isProlong}
                paramReq={selectedDeals}
                handleCloseModal={handleCloseModal}
                paramReqList={state}
                clientId={clientId}
                cashBoxId={dataActiveCashbox.value}
            />
            <CloseDealModal
                isOpen={state.isClosed}
                deals={selectedDeals}
                handleCloseModal={closeClosedDealModal}
                openBuyThirdPersonModal={openBuyThirdPersonModal}
                isBuyThirdPerson={state.isBuyThirdPerson}
                cashBoxId={dataActiveCashbox.value}
            />
            <PayAnnuityPeriod
                  isOpen={state.isPayAnnuity}
                  onClose={() => handleCloseModal(viewDocument.isPayAnnuity)}
                  dealId={selectedDeals[0]?.id}
                  item={selectedDeals}
                  updateData={refreshData}
                  dealNumber={selectedDeals[0]?.dealNumber}
              />
            <AlertModal
                isOpen={popup.isOpen}
                handleClose={closeAlertModal}
                header={popup.header}
                text={popup.text}
            />
            <ConfirmModal
                isOpen={state.isToTransfer}
                handleClose={() => handleCloseModal(viewDocument.isToTransfer)}
                handleAction={addToTransfer}
                headerText="Вы хотите переместить на передачу / в гараж?"
            />
            <Pagination
                total={Math.ceil(total / state.pageRange)}
                current={state.currentPage}
                handlePageChange={handlePageChange}
            />

            <BuyThirdPersonModal
                isOpen={state.isBuyThirdPerson.isOpen}
                onSubmitBuyThirdPerson={onSubmitBuyThirdPerson}
                closeBuyThirdPersonModal={closeBuyThirdPersonModal}
            />
            {
                state.isCloseAnnuityDeal && <CloseAnnuityDeal
                    isOpen={state.isCloseAnnuityDeal}
                    onClose={() => handleCloseModal(viewDocument.isCloseAnnuityDeal)}
                    dealId={ids}
                    items={selectedDeals}
                    dealNumber={''}
                    isBuyThirdPerson={state.isBuyThirdPerson}
                    openBuyThirdPersonModal={openBuyThirdPersonModal}
                    updateData={refreshData}
                />
            }
            <BasicAlert onClose={() => setAlertMessage(null)}
                message={alertMessage}
                isOpen={!!alertMessage}
                isError={true}
            />
        </>
    );
};

export default ClientContractTab;
